import { Config } from "./constant";
import { AgentCareStore } from "./Store";

let Resolver;
let Rejecter;
let message = null;

const promise = new Promise((resolve, reject) => {
  Resolver = resolve;
  Rejecter = reject;
});
const socket = new WebSocket(Config.websocketUrl);

socket.addEventListener("open", e => {
  Resolver();
  setInterval(timer, 45000);
});

socket.addEventListener("message", newMessage => {
  Resolver();
  let messageFromJs = JSON.parse(newMessage.data);

  if (messageFromJs.code === "session:created") {
    localStorage.setItem(Config.domainId(), messageFromJs.sessionId);
    let sessionJoin = JSON.stringify({
      code: "session:join",
      sessionId: messageFromJs.sessionId
    });
    send(sessionJoin);
  }

  if (messageFromJs.code === "session:joined") {
    if (messageFromJs.agent.is_online) {
      AgentCareStore.status = "online";
    } else {
      AgentCareStore.status = "offline";
    }
    if (messageFromJs.agent.picture_url !== null) {
      AgentCareStore.displayPicture = messageFromJs.agent.picture_url;
    } else {
      AgentCareStore.displayPicture = "";
    }
    message = messageFromJs.message;
  } else if (messageFromJs.code === "message:sent") {
    let messageFromCustomer = {
      from: messageFromJs.from,
      name: messageFromJs.name,
      text: messageFromJs.text,
      timestamp: messageFromJs.timestamp,
      type: messageFromJs.type
    };
    message.push(messageFromCustomer);
  } else if (messageFromJs.code === "message:rcv") {
    let messageFromAgent = {
      from: messageFromJs.from,
      name: messageFromJs.name,
      text: messageFromJs.text,
      timestamp: messageFromJs.timestamp,
      type: messageFromJs.type
    };
    message.push(messageFromAgent);
  } else if (messageFromJs.code === "agent") {
    if (messageFromJs.agent.is_online) {
      AgentCareStore.status = "online";
    } else {
      AgentCareStore.status = "offline";
    }
    if (messageFromJs.agent.picture_url !== null) {
      AgentCareStore.displayPicture = messageFromJs.agent.picture_url;
    } else {
      AgentCareStore.displayPicture = "";
    }
  }
});

export let send = data => {
  promise.then(() => {
    socket.send(data, function(err) {
      if (err) {
        console.log("ERR", err);
      }
    });
  });
};

export function getMessage() {
  return message;
}

function timer() {
  socket.send('{"code":"ping"}', function(err) {
    if (err) {
      console.log("Error On Websocket ", err);
    }
  });
}

export let closeConnection = () => {
  socket.close();
};



// WEBPACK FOOTER //
// ./src/Socket.js